import { Subject } from "rxjs";
import { webSocket } from "rxjs/webSocket";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var JourneySocketService = /** @class */ (function () {
    function JourneySocketService(http) {
        this.http = http;
        this.subject = new Subject();
    }
    /**
     * How to use
      this.wsConnection = this.datacontextService.journeySocket.connect();
      this.wsConnection.subscribe(
        (msg) => {
          console.log('WS:', msg);
        },
        (err) => {
          console.error('WS:', err);
        },
        () => console.log('complete')
      );
  
      this.wsConnection.next();
     */
    JourneySocketService.prototype.connect = function (sid) {
        var url = environment['wssocket_url'] + "/socket/" + sid + "?source=browser";
        this.subject = webSocket(url);
        return this.subject;
    };
    JourneySocketService.prototype.requestSession = function (appID, deviceID) {
        var payload = {
            app_id: appID,
            device_id: deviceID,
            source: 'browser'
        };
        var url = '/dashboard/visualizer/request_session';
        return this.http.post(url, payload).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    JourneySocketService.prototype.freeDevice = function (appID, deviceID) {
        var url = 'dashboard/visualizer/free_device/' + deviceID;
        var httpOptions = {
            headers: new HttpHeaders({
                'app-id': appID
            })
        };
        return this.http.get(url, httpOptions).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    JourneySocketService.ngInjectableDef = i0.defineInjectable({ factory: function JourneySocketService_Factory() { return new JourneySocketService(i0.inject(i1.HttpClient)); }, token: JourneySocketService, providedIn: "root" });
    return JourneySocketService;
}());
export { JourneySocketService };
